<template>
  <!-- v-if="msal.idToken" -->
  <v-app id="app" class="main-wrapper" v-if="msal.idToken">
    <div class="header">
      <div class="header__top">
        <div class="header__block">
          <h2 class="header__title">Arena 5.1 Admin Portal</h2>
          <p class="header__instance__title">[{{ instanceName }}]</p>
        </div>
        <div class="header__block header__login-box">
          <div class="header__login-actions">
            <NotificationBell />
            <div class="header__user-block">
              <p class="header__login-username">{{ userName }}</p>
              <a class="header__logout-link" @click="logout">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container" v-if="isApiErrorPresent">
      <div class="api-error__container">
        <p class="api-error__message" v-html="apiError">
        </p>
        <span class="close-link" @click="closeApiErrorMessage">Close</span>
      </div>
    </div>
    <FullScreenOverlay v-if="httpRequestInProgressCount > 0">
    </FullScreenOverlay>
    <router-view />
    <v-snackbar
      v-model="notifyState.visible"
      :color="notifyState.current && notifyState.current.color"
      :timeout="15000"
      top
      right
      multi-line
      @input="onNotifyInput"
    >
      {{ notifyState.current && notifyState.current.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="onNotifyClose"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
  <v-app id="app" class="main-wrapper" v-else>
    <v-dialog max-width="500" persistent v-model="dialog">
      <v-card >
        <v-card-title>Authentication required</v-card-title>
        <v-card-text>
          In order to use this app you need to have Arkadium's Azure account.
          Please, reach out somebody@arkadium.com if you have any troubles.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="$msal.signIn()">Sign in with Azure AD</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
  <!-- <FullScreenOverlay v-else-if="!msal.idToken"> -->
  <!-- </FullScreenOverlay> -->
</template>

<script>
import FullScreenOverlay from './components/FullScreenOverlay/FullScreenOverlay.vue'
import NotificationBell from './components/Notifications/NotificationBell.vue'
import { notifyStore, closeNotify } from './plugins/notify'

let env = process.env.NODE_ENV

export default {
  name: 'App',
  props: ['apiError', 'httpRequestInProgressCount'],
  components: { FullScreenOverlay, NotificationBell },
  data() {
    return {
      dialog: true,
      instanceName: env,
      notifyState: notifyStore
    }
  },
  methods: {
    closeApiErrorMessage: function () {
      this.$emit('apiErrorClosed')
    },
    onNotifyClose: function () {
      closeNotify()
    },
    onNotifyInput: function (val) {
      // When v-snackbar auto-hides (timeout) it sets v-model to false.
      // Advance the queue in that case.
      if (val === false) {
        closeNotify()
      }
    },
    logout: function () {
      this.$msal.signOut()
    },
  },
  computed: {
    isApiErrorPresent: function () {
      if (this.apiError && this.apiError !== '') {
        return true
      }
      return false
    },
    userName: function () {
      return this.msal.account?.name
    }
  }
}
</script>

<style src="./app.scss" lang="scss"></style>
